<figure [ngStyle]="setFigureStyles()" class="image-object">
  <div class="image-container" [ngStyle]="setImageContainerStyles()">
    <img appInspectImage *ngIf="imagePath" loading="lazy" [ngStyle]="setImageStyles()" [src]="imagePath" [alt]="imageObject?.alt ? imageObject?.alt : null" class="hover_image">
  </div>
  <figcaption [style.color]="captionColor" *ngIf="imageObject?.caption">
    <app-dynamic-content
      [contentId]="'image-object-caption'"
      [htmlContent]="imageObject.caption">
    </app-dynamic-content>
  </figcaption>
</figure>
